import type { IFavoriteTerritoryCell } from './favorite-territory-cell.types'

export const useFavoriteTerritoryCellModel = ({ row }: IFavoriteTerritoryCell) => {
  const [entityType] = row?.territoryId?.split('.') ?? []

  return {
    isFollowed: row.isFollowed,
    territoryId: row.territoryId,
    name: row.name,
    entityType,
  }
}
